// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f43bc4f1","378":"bb133d47","440":"b95f8d94","494":"a9c5a257","541":"9bc66e6b","598":"df08d393","671":"f7ddb146","784":"731ed1b1","824":"e4801e52","894":"32dd73d8"}[chunkId] + ".chunk.css";
};